export default function getResource(label) {
    const resources = {
        personalizedPlacements: 'Personalized Placements'
    };

    return resources[label];
}
